export default __webpack_public_path__ + "media/images/admin/wallet-251a717d5afda4397ac0d2eec7833600.svg";